import { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import api from "../services/api";

export default function PaymentSuccess() {
  const [params] = useSearchParams();
  const navigate = useNavigate();

  const reference = params.get("reference");
  const [status, setStatus] = useState("verifying"); 
  const [message, setMessage] = useState("");

  useEffect(() => {
    const verify = async () => {
      try {
        if (!reference) {
          setStatus("failed");
          setMessage("Invalid payment reference");
          return;
        }

        await api.post("/payment/verify", { reference });

        setStatus("success");
        setMessage("Your subscription has been successfully activated!");

        setTimeout(() => navigate("/user-dashboard"), 3000);
      } catch (err) {
        setStatus("failed");
        setMessage("Payment verification failed.");
      }
    };

    verify();
  }, [reference, navigate]);

  return (
    <div className="container d-flex justify-content-center align-items-center" style={{ minHeight: "70vh" }}>
      <div className="card shadow-lg p-5 text-center" style={{ maxWidth: "500px", width: "100%" }}>
        
        {status === "verifying" && (
          <>
            <div className="spinner-border text-primary mb-3" role="status"></div>
            <h3>Verifying your payment...</h3>
            <p className="text-muted">Please wait while we confirm your transaction.</p>
          </>
        )}

        {status === "success" && (
          <>
            <div className="text-success" style={{ fontSize: "50px" }}>✓</div>
            <h3 className="mt-3">Payment Successful!</h3>
            <p>{message}</p>
            <p className="text-muted">Redirecting to your dashboard...</p>
          </>
        )}

        {status === "failed" && (
          <>
            <div className="text-danger" style={{ fontSize: "50px" }}>✕</div>
            <h3 className="mt-3">Verification Failed</h3>
            <p>{message}</p>
            <button className="btn btn-secondary mt-3" onClick={() => navigate("/upgrade")}>
              Try Again
            </button>
          </>
        )}

      </div>
    </div>
  );
}